import { useTranslation } from "react-i18next";

import { Card, CardContent, Stack, Typography } from "@mui/material";

import CustomButton from "../common/CustomButton";


import "./FileImportCard.sass";

const FileImportCard = ({ fileName, onProcessClick, onClose }) => {
  const { t } = useTranslation();
  return (
    <Stack spacing={2} width="100%">
      <Card>
        <CardContent>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h5">
              {`${t("selected_file_name")}${fileName}`}
            </Typography>
            <Stack direction={'row'} gap={1}>
              <CustomButton
                datatestid="process"
                className="custom_remove_import"
                size="small"
                btnType="outlined"
                onClick={onClose}
              >
                {t("close")}
              </CustomButton>
              <CustomButton
                datatestid="process"
                className="bid_buttons_import"
                size="small"
                btnType="outlined"
                onClick={onProcessClick}
              >
                {t("process")}
              </CustomButton>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
};

export default FileImportCard;
